<template>
  <base-modal :id="id" :title="title" :modal-busy="collectionBusy" :size="size" v-model="modalState" >
    <pagination v-if="!collection_title && searchCollectionList.length" :meta="searchCollectionListMeta" :search-width="50" place-holder="توپلام نامىنى كىرگۈزۈپ ئىزدەڭ" @change-page="onChangePage" @refresh="onRefresh" />
    <b-row v-if="searchCollectionList.length">
      <b-col v-for="(collection, index) in searchCollectionList" :key="collection.id" cols="4" md="2" class="mb-4">
        <collection-item :index="index" :item="collection" :selected="currentSelected === collection.id" @changed="onChangeCollectionItem" />
      </b-col>
    </b-row>
    <no-result visible v-else title="توپلام ئۇچۇرى يوق" desc="ھازىرچە مۇناسىۋەتلىك توپلام ئۇچۇرى يوق ئىكەن ." />
  </base-modal>
</template>

<script>
  import baseModal from "./base.modal";
  import CollectionItem from "@v@/components/items/CollectionItem";
  import pagination from "@v@/components/paginate";
  import NoResult from "@v@/partials/content/NoResult";

  import collectionMixin from "@m@/collection.mixin";
  import collectionBusyMixin from "@m@/common/formBusy.mixin";
  export default {
    name: "searchFilmCollectionModal",
    components: { baseModal, CollectionItem, pagination, NoResult },
    props: {
      id: {
        type: String,
        default: () => 'search-film-collection-modal'
      },
      value: {
        type: Boolean,
      },
      title: {
        type: String,
        default: () => 'توپلام ئىزدەڭ'
      },
      size: {
        type: String,
        default: ()=> 'lg'
      },
      selected: {
        type: [String, Number]
      }
    },
    computed: {
      modalState: {
        get(){
          return this.value;
        },
        set(v){
          this.$emit('input', v);
        },
      },
      currentSelected(){
        if (this.selectedForComponentEvent){
          return this.selectedForComponentEvent
        }else if (this.selected){
          return this.selected
        }
        return null;
      },
    },
    mixins: [ collectionMixin, collectionBusyMixin ],
    created() {
      this.searchCollection(1);
    },
    data(){
      return {
        collectionBusy: false,
        page: 1,
        collection_title: '',
        selectedForComponentEvent: null
      };
    },
    methods: {
      onChangePage(e){
        let { title, page } = e;
        this.page = page;
        this.collection_title = title;
        this.searchCollection(page, title);
      },
      onRefresh(title){
        this.searchCollection(1, title);
      },
      onChangeCollectionItem(e){
        let { index, collection } = e;
        this.updateSelectedForComponentEvent(collection.id);
        this.$emit('changed', { collection });
      },
      updateSelectedForComponentEvent(selectedForComponentEvent = null){
        this.selectedForComponentEvent = selectedForComponentEvent;
      }
    }
  }
</script>

<style scoped>

</style>
